<template>
  <div class="container calendar">
    <calendar-sorting
      @selectView="(view) => selectView(view)"
      @changeDateStart="(newStartDay) => changeDateStart(newStartDay)"
      @search="(searchString) => searchTicker(searchString)"
      @selectEventCategory="
        ({ type: type, active: isActive }) =>
          selectEventCategory(type, isActive)
      "
      :selectedView="selectedView"
      :startDay="startDay"
      :endDay="endDay"
    ></calendar-sorting>
    <MonthList
      v-if="selectedView === 'month'"
      :month="arrayOfDates"
      @changeViewToWeek="(newStartDay) => changeViewToWeek(newStartDay)"
    />
    <WeekList v-if="selectedView === 'week'" :week="arrayOfDates" />
  </div>
</template>

<script>
import CalendarSorting from '@/components/Calendar/CalendarSoritng'
import MonthList from '@/components/Calendar/MonthList'
import WeekList from '@/components/Calendar/WeekList'

export default {
  data() {
    const startView = 'month'
    return {
      selectedView: this.$route.query.detail || startView,
      startDay: new Date(
        this.getFirstDay(
          this.$route.query.dS
            ? this.fromISOStringtoDate(this.$route.query.dS)
            : new Date(),
          this.$route.query.detail || startView
        )
      ),
      loadedDates: new Array(),
      objectOfFilters: new Object(),
      selectedEvents: new Array(),
      localTimeZone: new Date().getTimezoneOffset() * 60 * 1000,
    }
  },
  computed: {
    endDay() {
      let date = this.startDay
      if (this.selectedView === 'month') {
        let lastDayOfMonth = new Date(
          date.getFullYear(),
          date.getDate() > 22 ? date.getMonth() + 2 : date.getMonth() + 1,
          0
        )
        return new Date(
          lastDayOfMonth.getFullYear(),
          lastDayOfMonth.getMonth(),
          lastDayOfMonth.getDate() +
            (lastDayOfMonth.getDay() === 0 ? 0 : 7 - lastDayOfMonth.getDay())
        )
      } else {
        return new Date(date.getFullYear(), date.getMonth(), date.getDate() + 6)
      }
    },
    routing() {
      return `${this.startDay}|${this.selectedView}`
    },
    arrayOfDates() {
      // if there are no filters in the object
      return Object.keys(this.objectOfFilters).length > 0
        ? // filter dates
          this.filterDates(this.loadedDates, this.objectOfFilters)
        : // return loaded data
          this.loadedDates
    },
  },
  mounted() {
    this.$store
      .dispatch('request/getCalendarEvents', {
        selectedView: this.selectedView,
        startDay: this.startDay,
        endDay: this.endDay,
      })
      .then((data) => {
        this.loadedDates = this.addDaysAndSort(data)
      })
    if (this.$route.query.dS)
      this.$router
        .push({
          query: {
            detail: this.selectedView,
            dS: new Date(this.$route.query.dS).toISOString().slice(0, 10),
          },
        })
        .catch((err) => {
          // Ignore the vuex err regarding  navigating to the page they are already on.
          if (
            err.name !== 'NavigationDuplicated' &&
            !err.message.includes(
              'Avoided redundant navigation to current location'
            )
          ) {
            // But print any other errors to the console
            console.error(err)
            this.$store.dispatch('layout/showMessage', {
              type: 'error',
              title: err.name,
              message: err.message,
              timeout: 5000,
            })
          }
        })
  },
  watch: {
    routing: function(newDayAndViewMode) {
      let [newDay, newViewMode] = newDayAndViewMode.split('|')
      this.loadedDates = []
      newDay = new Date(newDay)
      if (newViewMode === 'month') {
        newDay = new Date(
          newDay.getFullYear(),
          newDay.getDate() > 23 ? newDay.getMonth() + 1 : newDay.getMonth(),
          1
        )
      }
      newDay = this.getDateWithLocalTimeZone(newDay)
      this.$router.push({
        query: {
          detail: newViewMode,
          dS: newDay.toISOString().slice(0, 10),
        },
      })
      this.$store
        .dispatch('request/getCalendarEvents', {
          selectedView: this.selectedView,
          startDay: this.startDay,
          endDay: this.endDay,
        })
        .then((data) => {
          this.loadedDates = this.addDaysAndSort(data)
        })
    },
  },
  methods: {
    selectView(selectedTimeInterval) {
      this.selectedView = selectedTimeInterval
      let lastDayOfWeek = new Date(
        this.startDay.getFullYear(),
        this.startDay.getMonth(),
        this.startDay.getDate() + 6
      )
      this.startDay = this.getFirstDay(
        selectedTimeInterval === 'month' ? lastDayOfWeek : this.startDay
      )
    },
    getFirstDay(date, mode) {
      if (mode === 'week' || this.selectedView === 'week')
        return new Date(
          date.getFullYear(),
          date.getMonth(),
          date.getDate() - (date.getDay() === 0 ? 7 : date.getDay()) + 1
        )
      if (mode === 'month' || this.selectedView === 'month') {
        let firstDayOfMonth = new Date(date.getFullYear(), date.getMonth(), 1)
        return new Date(
          firstDayOfMonth.getFullYear(),
          firstDayOfMonth.getMonth(),
          firstDayOfMonth.getDate() -
            (firstDayOfMonth.getDay() === 0 ? 7 : firstDayOfMonth.getDay()) +
            1
        )
      }
    },
    changeDateStart(date) {
      this.startDay = this.getFirstDay(date)
    },
    addDaysAndSort(array) {
      // add days without events
      for (let i = +this.startDay; i <= +this.endDay; i += 86400000) {
        if (!array.find((item) => item.date >= i && item.date < i + 86400000))
          array.push({ date: i + '', events: [] })
      }

      // delete duplication of dates:
      // 1. make object from array with data keys
      let obj = {}
      array.forEach((item) => {
        let key = new Date(+item.date).toDateString()
        obj[key] ? obj[key].push(...item.events) : (obj[key] = item.events)
      })
      // 2. make array from object again
      let newArray = []
      for (let item in obj) {
        newArray.push({ date: +new Date(item), events: obj[item] })
      }
      // set params for search
      const filterParams = ['CompanyName_en', 'CompanyName_ru']
      // add string for search
      newArray.forEach((item) => {
        item.events.forEach((ev) => {
          ev.searchString = filterParams.map((param) => ev[param]).join(' ')
          if (this.selectedView === 'week')
            ev.searchString =
              ev.searchString + ' ' + ev.title_ru + ' ' + ev.title_en
          ev.searchString = ev.searchString.toLowerCase()
        })
      })
      // sort and return array
      return newArray.sort((prev, next) => prev.date - next.date)
    },
    fromISOStringtoDate(date) {
      const arrayOfDate = date.split('-')
      return new Date(arrayOfDate[0], arrayOfDate[1] - 1, arrayOfDate[2])
    },
    getDateWithLocalTimeZone(date) {
      return new Date(+new Date(date) - this.localTimeZone)
    },
    changeViewToWeek(day) {
      this.startDay = this.getFirstDay(new Date(+day.date), 'week')
      this.selectView('week')
    },
    selectEventCategory(type, isActive) {
      if (isActive) {
        // if eventType is activated
        this.selectedEvents.push(type)
      } else {
        // if not, delete this
        this.selectedEvents.splice(this.selectedEvents.indexOf(type), 1)
      }
      let callbackSelectEvent = (item) => {
        return this.selectedEvents.find((elem) => item.cat === elem)
      }
      // clone new object to watch changes in objectOfFilters
      this.objectOfFilters = Object.assign({}, this.objectOfFilters)
      this.selectedEvents.length > 0
        ? (this.objectOfFilters['selectEvent'] = callbackSelectEvent)
        : delete this.objectOfFilters['selectEvent']
    },
    searchTicker(value) {
      // make callback to move it in objectOfFilters
      const searchValue = value.toLowerCase()
      let callbackSearchTicker = (item) => {
        // find searchValue in event
        return item.searchString.indexOf(searchValue) !== -1
      }
      // clone new object to watch changes in objectOfFilters
      this.objectOfFilters = Object.assign({}, this.objectOfFilters)
      value.length > 0
        ? (this.objectOfFilters['searchTicker'] = callbackSearchTicker)
        : delete this.objectOfFilters['searchTicker']
    },
    filterDates(array, filters) {
      // make array from object of filters
      let arrayOfFilters = []
      for (let prop in filters) {
        arrayOfFilters.push(filters[prop])
      }
      // for each event in array of dates
      return array.map((item) => {
        // make new object to copy event from array
        let newItem = Object.assign({}, item)
        // filter events
        newItem.events = item.events.filter((item) => {
          // call every filter of the array
          return arrayOfFilters.reduce((prev, filter) => {
            return (
              // and calculate the result of callbacks
              prev && filter(item)
            )
          }, true)
        })
        return newItem
      })
    },
  },
  components: {
    'calendar-sorting': CalendarSorting,
    MonthList,
    WeekList,
  },
}
</script>

<style lang="scss">
.calendar {
  position: relative;
  padding: 2.53333rem 1.2rem;
  &_active {
    &_month {
      color: $title-color;
    }
    &_day {
      color: #d6005a;
    }
  }

  @media (max-width: 576px) {
    padding: 6px 12px;

    &_active {
      &_day {
        color: $primary-color2;
      }
    }
  }
}

#app[data-theme='dark'] {
  .calendar {
    &_active {
      &_month {
        color: #fff;
      }
      &_day {
        color: #d6005a;
      }
    }
  }
}
</style>
